import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  endpointState: null,
} as QiotTestState

const qiotTestSlice = createSlice({
  name: 'qiotTest',
  initialState,
  reducers: {
    setQiotTest: (state, action) => ({ ...state, ...action.payload }),
    setQiotTestPortStatus: (state, action) => {
      if (state.endpointState) {
        const port = state.endpointState.ports?.[action.payload.portId]
        if (port) {
          // eslint-disable-next-line no-param-reassign
          port.isOpen = action.payload.isOpen
        } else {
          // eslint-disable-next-line no-param-reassign
          state.endpointState.ports = (state.endpointState.ports || []).concat({ isOpen: action.payload.isOpen })
        }
      }
    },
    resetQiotTest: (_, action) => ({ ...initialState, ...action.payload }),
  },
})

export const { setQiotTest, setQiotTestPortStatus, resetQiotTest } = qiotTestSlice.actions

export default qiotTestSlice.reducer
